module.exports = __webpack_public_path__ + "img/selected_1.21923f69.svg";